<template>
  <div class="text-center">
    <v-snackbar
      :value="alerting"
      :timeout="5000"
      :color="message_alert.color"
      text
      top
      centered
      transition="slide-y-transition"
      v-if="message_alert != null"
    >
      <v-row no-gutters>
        <v-col cols="auto" align-self="center">
          <v-icon :color="message_alert.color" class="mr-3"
            >{{iconStatus}}</v-icon
          >
        </v-col>
        <v-col class="alertTitle" align-self="center">
          {{ message_alert.message_status }}
        </v-col>
      </v-row>

      <template #action="{ attrs }">
        <v-btn
          color="text_black"
          class="pa-0 mx-4"
          min-width="inherit"
          text
          v-bind="attrs"
          @click="finish"
        >
          <v-icon color="text_black">mdi-window-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'AlertComponent',
  data () {
    return {}
  },
  computed: {
    ...mapGetters({
      alerting: 'alerting',
      message_alert: 'message_alert'
    }),
    iconStatus () {
      return this.message_alert.color === '#58A144' ? 'mdi-check-circle-outline' : 'mdi-alert-circle-outline'
    }
  },
  watch: {
    alerting (val) {
      if (!val) return
      setTimeout(() => this.$store.commit('offAlerting'), 6000)
    }
  },
  methods: {
    // start() {
    //     this.$store.commit("on");
    // },
    finish () {
      this.$store.commit('offAlerting')
    }
  }
}
</script>
<style scoped>
.alertTitle{
  font-family: Noto Sans Thai !important;
  font-weight: 600;
  font-size: 14px;
  color: #000000;
  margin-bottom: 0px !important;
}
.alertsubTitle{
  font-weight: 400;
  font-size: 14px;
  color: #6C757D;
  margin-bottom: 0px !important;
}
</style>
